import esDataLanguage from '../../../../assets/i18n/es-ES.json';
import enDataLanguage from '../../../../assets/i18n/en-EN.json';

import { UPDATE_LANGUAGE_EVENT } from '@core/constants/EVENTS';
import { DEFAULT_LANGUAGE } from '@core/constants/DEFAULT';

const selectedLanguage =
    window.wesogSelectedLanguage || navigator.language || DEFAULT_LANGUAGE;

// let /** @type {String} */ selectedLanguage = DEFAULT_LANGUAGE;

// /* Check if the code is running in a Service Worker context */
// const isServiceWorker =
//     typeof self !== 'undefined' && self.constructor.name === 'ServiceWorkerGlobalScope';

// if (!isServiceWorker) {
//     // Code that relies on `window`
//     selectedLanguage = window.navigator.language || window.navigator.userLanguage;
// }

/**
 * Fetch the language file.
 * @type {function}
 * @returns {Promise<void>}
 */
export const fetchLanguage = (currentSelectedLanguage = selectedLanguage) => {
    const currentLanguageData =
        currentSelectedLanguage === DEFAULT_LANGUAGE ? esDataLanguage : enDataLanguage;

    if (currentLanguageData) {
        window.wesogSelectedLanguage = currentSelectedLanguage;
        window.wesogTranslate = currentLanguageData;
    } else {
        console.error('Impossible to load the i18n file:', currentSelectedLanguage);
    }
};

document.addEventListener('DOMContentLoaded', function () {
    fetchLanguage();

    document.dispatchEvent(
        new CustomEvent(UPDATE_LANGUAGE_EVENT, {
            detail: {
                language: selectedLanguage,
            },
        }),
    );
});
